

















































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'
import { StatusReason } from '@/api/model/status-reason'
import { cloneDeep, isEqual } from 'lodash'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'

@Component
export default class EditStatusReasonForm extends Vue {
    @Prop() readonly statusReason!: StatusReason
    @Prop({ default: null }) readonly pipeline!: Pipeline|null
    editingStatusReason: StatusReason = null
    phaseStatusReasonIds: string[] = []
    @Prop({ default: false }) readonly inUse!: boolean
    @Prop({ default: true }) readonly removable!: boolean
    @Prop({ default: false }) readonly removing!: boolean
    @Prop({ default: false }) readonly saving!: boolean

    mounted() {
        this.editingStatusReason = cloneDeep(this.statusReason)
        this.phaseStatusReasonIds = this.statusReason.phases.map(phase => phase.id)
    }

    get phases(): PipelinePhase[] {
        if (!this.pipeline) {
            return []
        }

        return this.pipeline.phases
    }

    @Watch('statusReason', { immediate: true })
    onStatusReasonChanged(): void {
        this.editingStatusReason = cloneDeep(this.statusReason)
    }

    get isDirty(): boolean {
        return !isEqual(this.editingStatusReason, this.statusReason)
    }

    onCancelClick() {
        this.$emit('cancel', this.editingStatusReason)

        // Reset form to initial state
        this.onStatusReasonChanged()
    }

    onRemoveClick() {
        this.$emit('remove-status-reason', this.editingStatusReason)
    }

    onSaveClick() {
        this.$emit('save-status-reason', this.editingStatusReason)
    }

    setPhaseReasons(selectedPhases): void {
        this.phaseStatusReasonIds = selectedPhases
        this.editingStatusReason.phases = this.pipeline.phases.filter(phase => selectedPhases.includes(phase.id))
    }

    get phaseOptions(): Array<{label: string, value: string}> {
        return this.phases.map(phase => ({label: phase.name, value: phase.id}))
    }

    get isStatusOpen(): boolean {
        return this.statusReason.status === 'open'
    }
}
